import { render, staticRenderFns } from "./promotionUrl.vue?vue&type=template&id=2ee63b56"
import script from "./promotionUrl.vue?vue&type=script&lang=js"
export * from "./promotionUrl.vue?vue&type=script&lang=js"
import style0 from "./promotionUrl.vue?vue&type=style&index=0&id=2ee63b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports